<template>
  <PageLoader v-if="isLoadingFiche" />
  <div class="card">
    <div class="card-header">
      <div class="card-title" v-if="fiches?.length > 0">{{ $t('projects.fiches.fiche') }}</div>
      <div class="card-title" v-else></div>
      <div class="card-toolbar" v-if="showGenerate || fiches?.length == 0">
        <div class="d-flex justify-content-end">
          <Button btn-class="btn-sm me-3" type="new" @click="addInfo" btn-text="projects.fiches.add_info"></Button>
          <Button btn-class="btn-sm me-3" type="new" @click="selectInfoModal" btn-text="projects.fiches.select_info_exist"></Button>
        </div>
      </div>
    </div>
    <div class="card-body" style="overflow-y: auto; max-height: 450px !important;">
      <div v-if="fiches?.length == 0 && !showGenerate" class="text-center">
        <div class="pt-8">
          <Img filename="empty.png" alt="" class="mw-100 h-125px h-sm-175px" />
        </div>
        <h2 class="fs-2x fw-bolder mb-0">{{ $t('projects.fiches.no_data_found') }}</h2>
        <br>
      </div>
      <div v-if="fiches?.length > 0">
        <div v-if="!showGenerate" v-for="char in fiche?.details" :key="char.id">
          <div v-if="!char?.is_generated" class="d-flex fs-4 justify-content-between mb-8">
            <div class="col-5 fw-bold text-muted">{{getEnumName(char.field)[locale]}}</div>
            <div class="col-7 fw-bold" v-html="char[char.field] ?? char[locale]"></div>
          </div>
          <div v-if="char?.is_generated" class="d-flex fs-4 justify-content-between mb-8" v-for="(data, index) in char.data" :key="`${key}-${index}`">
            <div class="col-5 fw-bold text-muted">{{data.key}}</div>
            <div class="col-7 fw-bold">{{data.value}}</div>
          </div>
        </div>
      </div>
      <div v-if="showGenerate">
        <div v-for="(char, key) in formDataFiche.details" :key="key">
          <div class="row mb-5 d-flex align-items-center" v-if="!char?.is_generated">
            <Input
              container-class="form-group col-12 col-md-5"
              :name="`caracteristics_name_`+key"
              type="text"
              :inputClass="'form-control form-control-lg form-control-solid'"
              size="lg"
              :placeholder="$t('projects.estates.caracteristic_placeholder')"
              :isRequired="true" 
              v-model="char.name"
              :readonly="true"
            />
            <Input
              container-class="form-group col-12 col-md-6"
              :name="`caracteristics_value_`+key"
              type="text"
              :inputClass="'form-control form-control-lg form-control-solid'"
              size="lg"
              :placeholder="$t('projects.estates.caracteristic_value_placeholder')"
              :isRequired="false" 
              v-model="char.value"
            />
            <div class="col-12 col-md-1 d-flex justify-content-end">
              <div :style="{'border': '1px solid '+ $getCssVariable('--bs-danger') }" :title="$t('button.delete')" class="btn btn-icon btn-icon-muted btn-active-light w-40px h-40px" type="button" @click="remove(key)">
                <i class="fas fa-trash fs-3 text-danger"></i>
              </div>
            </div>
          </div>
          <div v-if="char?.is_generated" class="row mb-5 d-flex align-items-center" v-for="(data, index) in char.data" :key="`${key}-${index}`">
              <Input
                container-class="form-group col-12 col-md-5"
                :name="`caracteristics_name_${key}_${index}`"
                type="text"
                :inputClass="'form-control form-control-lg form-control-solid'"
                size="lg"
                :placeholder="$t('projects.estates.caracteristic_placeholder')"
                :isRequired="true" 
                v-model="data.key"
              />
              <Input
                container-class="form-group col-12 col-md-6"
                :name="`caracteristics_value_${key}_${index}`"
                type="text"
                :inputClass="'form-control form-control-lg form-control-solid'"
                size="lg"
                :placeholder="$t('projects.estates.caracteristic_value_placeholder')"
                :isRequired="false" 
                v-model="data.value"
              />
              <div class="col-12 col-md-1 d-flex justify-content-end">
                <div :style="{'border': '1px solid '+ $getCssVariable('--bs-danger') }" class="btn btn-icon btn-icon-muted btn-active-light w-40px h-40px" type="button" @click="remove(key)">
                  <i class="fas fa-trash fs-3 text-danger"></i>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer" v-if="showGenerate || fiches?.length > 0">
      <div class="d-flex justify-content-end">
        <Button type="new" v-if="!showGenerate && fiches?.length > 0" @click="clickOnDetail('generate')" btn-class="btn-sm me-3" size="7px 30px" btn-text="projects.fiches.update_fiche"></Button>
        <Button type="cancel" v-if="showGenerate && fiches?.length > 0" @click="clickOnDetail('fiche')" btn-class="btn-sm me-3" size="7px 30px" btn-text="back"></Button>
        <Button type="new" v-if="showGenerate" @click="generate" btn-class="btn-sm me-3" size="7px 30px" btn-text="projects.fiches.save_modification" :isLoading="isLoadingGenerate"></Button>
        <Button type="new" v-if="!showGenerate && fiches?.length > 0" @click="downloadFiche" btn-class="btn-sm" size="7px 30px" backgroundColor="#0A0909" btn-text="button.download" :isLoading="downloading"></Button>
      </div>
    </div>
  </div>

  <CreateInformation id="add_information_to_fiche" @load="loadData" :fiche="fiche"/>
  <SelectInformation id="select_information_modal" @load="loadData" :fiche="fiche"/>
</template>

<script setup> 
  import {computed, onMounted, ref, watch} from "vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button";
  import { useRoute, useRouter } from "vue-router";
  import Img from "@/components/Img.vue";
  import PageLoader from "@/components/PageLoader.vue";
  import Input from "@/components/Input.vue";
  import CreateInformation from "./modals/CreateInformation.vue";
  import SelectInformation from "./modals/SelectInformation.vue";
  import { useLocales } from "@/composables/locales";
  import { useSwal } from "@/composables/useSwal";

  const store = useStore()
  const route = useRoute()
  const router = useRouter()
  const {locale} = useLocales()
  const { showSwal } = useSwal();

  const fiches = computed(() => store.getters['projects/getProjectSummaries'])
  const showGenerate = computed(() => (!route.query.detail || route.query.detail == 'fiche') ? false : true)
  const sheetEnums = computed(() => store.getters['projects/getProjectSheetEnum'])

  const formDataFiche = ref({
    project_id: '',
    summary_id: '',
    details: []
  })
  const isLoadingFiche = ref(true)
  const downloading = ref(false)
  const isLoadingGenerate = ref(false)
  const fiche = ref({})

  watch(
    () => fiches.value,
    (value) => {
      showDetail()
    },
    { deep: true }
  )

  watch(
    () => fiche.value,
    (newVal) => {
      formDataFiche.value = {...newVal, summary_id: newVal.id}
      formDataFiche.value.details = fiche.value.details?.map((item) => {
        let field = item.field
        let name = !item?.is_generated ? getEnumName(item.field)[locale.value] : ''
        let value = item[field] ?? item[locale.value]
        return {...item, name: name, field: field, value: stripTags(value)}
      })
    },
    { deep: true }
  )

  watch(
    () => showGenerate.value,
    (value) => {
      if(value){
        formDataFiche.value.details = fiche.value.details?.map((item) => {
          let field = item.field
          let name = !item?.is_generated ? getEnumName(item.field)[locale.value] : ''
          let value = item[field] ?? item[locale.value]
          return {...item, name: name, field: field, value: stripTags(value)}
        })
      }
    },
    { deep: true }
  )

  function getEnumName(value) {
    const {fr, en} = sheetEnums.value?.filter(el => el.value == value)[0] || ''
    return {fr, en}
  }

  function stripTags(html) {
    const div = document.createElement("div")
    div.innerHTML = html
    return div.textContent || div.innerText || ""
  }

  function generate() {
    if(fiches.value?.length > 0){
      changeView()
    }else{
      selectInfoModal()
    }
  }

  function selectInfoModal() {
    $('#select_information_modal').modal('toggle')
  }

  function addInfo(){
     $('#add_information_to_fiche').modal('toggle')
  }

  function downloadFiche() {
    downloading.value = true
    store.dispatch('projects/downloadProjectSummary', fiche.value?.id)
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', i18n.global.t('projects.fiches.fiche')+'.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.toastr["success"](i18n.global.t('notification.fiche_downloaded'));
        })
        .finally(() => downloading.value = false)
  }

  function changeView() {
    if(showGenerate.value){
      isLoadingGenerate.value = true
      formDataFiche.value.project_id = route.params.id
      formDataFiche.value.summary_id = fiche.value?.id 
      store.dispatch('projects/updateProjectSummary', formDataFiche.value)
          .then(res => {
            loadData()
            window.toastr["success"](i18n.global.t('notification.fiche_generated'));
            closeView()
          })
          .finally(() => isLoadingGenerate.value = false)
    }else{
      clickOnDetail('generate')
    }
  }

  function showDetail() {
    if(fiches.value?.length > 0){
      store.dispatch('projects/showProjectSummary', fiches.value[0]?.id)
          .then(res => {
            fiche.value = res.data.summary_sheet
          })
    }
  }

  function closeView() {
    formDataFiche.value.details = []
    clickOnDetail('fiche')
  }

  function clickOnDetail(value){
    router.replace({ query: { ...route.query, detail: value } });
  }

  function remove(key){
    let length = formDataFiche.value.details?.length
    showSwal(
        '',
        i18n.global.t('projects.fiches.swal_delete_text')
    ).then( async (result) => {
      if (result.value) {
        if(length > 1) {
          formDataFiche.value.details.splice(key, 1)
        }
        if(length == 1) {
          store.dispatch('projects/deleteProjectSummary', fiche.value?.id).then(() => {
            formDataFiche.value.details.splice(key, 1)
            fiche.value = {}
            isLoadingFiche.value = true
            clickOnDetail('fiche')
            loadData()
          })
        }
      }
    });
  }

  function loadData() {
    store.dispatch('projects/loadProjectSummary', route.params.id).then(() => {
      isLoadingFiche.value = false
    })
  }

  onMounted(() => {
    loadData()
    store.dispatch('projects/loadSheetSummary')
  })
</script>
<style scope>
  .back{
    background-color: var(--bs-light-primary);
    border-radius: 8px;
    padding: 10px;
    width: auto;
  }
</style>